import type React from 'react'

/**
 * One field a view-options section renders. Purely presentational: `identifier` names the
 * payload/URL token the section reports back, `label` is the visible name, and `icon` is an
 * already-resolved component.
 *
 * The section components speak only this shape — they carry no notion of item types, roles,
 * or the catalog a field was projected from. A surface's domain adapter turns its own field
 * descriptors into `FieldOption`s and hands each section the slice it should render.
 */
export interface FieldOption {
  identifier: string
  label: string
  icon: React.ComponentType<{size?: number}>
}

/** Look a field up by its identifier, or `undefined` when the list holds none. */
export function findField(fields: readonly FieldOption[], identifier: string | null): FieldOption | undefined {
  if (identifier === null) return undefined
  return fields.find(field => field.identifier === identifier)
}
